<template>
  <div class="level container">
    <div class="row">
      <div class="col-md-5">
        <router-link class="btn draw-border back back-level"  :to="{ name: 'levels', params: { level: apt.level }}">
          Back to
          <span v-if="apt.level != 0">
            Level {{ apt.level }}
          </span>
          <span v-else>
            Ground
          </span>

        </router-link>
      </div>
    </div>
     <div class="row ">
      <div class="col-md-9">
        <div class="image-wrapper animated fadeInUp">
          <img :src="require(`@/assets/floorplan/${this.typical}.jpg`)" alt="Level image">
        </div>
         <ul class="upgrade-table animated fadeInUp">
            <li>01.Pendant Light</li>
            <li>02.Wall Shelf</li>
            <li>03.Semi-Integrated Fridge</li>
          </ul>
      </div>


      <div class="col-md-3 ">
        <h2 class="table-heading graphik-light-web animated fadeInUp">
          <span v-if="apt.level == 0">
            Ground level
          </span>
          <span v-else>
            Level {{ apt.level }}<br />
          </span>
          <span class="semi-bold">Apartment {{ apt.name }}</span>
        </h2>

        <table class="info-table animated fadeInUp">
          <tr>
            <td>Bedroom</td>
            <td class="table-value">{{ apt.bedrooms }}</td>
          </tr>
          <tr>
            <td>Bathroom</td>
            <td class="table-value">{{ apt.bedrooms }}</td>
          </tr>
          <tr>
            <td>Carpark</td>
            <td class="table-value">{{ apt.parking }}</td>
          </tr>
          <tr>
            <td>Floorplan area </td>
            <td class="table-value">{{ apt.floor_area }} m<sup>2</sup></td>
          </tr>
          <tr>
            <td>Balcony area </td>
            <td class="table-value">{{ apt.balcony_area }} m<sup>2</sup></td>
          </tr>
          <tr class="semi-bold">
            <td>Total area</td>
            <td class="table-value">{{ apt.total_area }} m<sup>2</sup></td>
          </tr>
        </table>

        <div class="keyplan-wrapper animated fadeInUp">
          <p>
            <strong>Keyplan</strong><br />
            <span>Level {{ apt.level }}</span>
          </p>
          <img :src="require(`@/assets/keyplan/${this.typical}.jpg`)" alt="Level image">
        </div>

      </div>

    </div>
  </div>
</template>

<style lang="scss">
  .info-table {
    width: 100%;
    color: $black;
    tr {
      border-bottom: 1px solid $black;
    }
    td {
      padding-top:6px;
      padding-bottom:6px;
    }
    .table-value {
      text-align:right;
    }
  }
  .keyplan-wrapper {
    margin-top: 20px;
  }
  .back-level {
    width: 160px !important;
  }
  .upgrade-table {
    padding-left: 15px;;
  }
</style>


<script>
export default {
  data() {
    return {
      apt: '',
      typical: ''
    }
  },
  created() {
    this.apt = this.$store.getters.getApartmentByNumber(this.$route.params.apartment);
    this.typical = this.$store.getters.getTypicalFromNumber(this.$route.params.apartment)
  }
}
</script>
